export default (function (_ref) {
  var service = _ref.service,
    request = _ref.request;
  return {
    // 列表
    getUsedCategoryList: function getUsedCategoryList() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/usedCategory/get",
        method: "get",
        params: data
      });
    },
    // 保存
    saveUsedCategory: function saveUsedCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/usedCategory/addOrUpdate",
        method: "post",
        data: data
      });
    },
    // 删除
    deleteUsedCategory: function deleteUsedCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/usedCategory/delete",
        method: "delete",
        params: data
      });
    },
    // 二手物品-更新权重
    sortUsedCategory: function sortUsedCategory() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/usedCategory/updateWeight",
        method: "post",
        data: data
      });
    },
    // 更新分类分享卡片
    updateCategoryCard: function updateCategoryCard() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return request({
        url: "/api/v3/admin/usedCategory/updateCategoryCard",
        method: "post",
        data: data
      });
    } // 添加
    // addUsedCategory(data = {}) {
    //     return request({
    //         url: "/admin/used_category/add",
    //         method: "post",
    //         data
    //     });
    // },
    // 更新
    // updateUsedCategory(data = {}) {
    //     return request({
    //         url: "/admin/used_category/update",
    //         method: "post",
    //         data
    //     });
    // },
  };
});